import React from "react";

interface Props {
  cover?: string;
  coverTrack?: string;
  trackName?: string;
  artist?: string;
  overtop?: boolean;
}

const InfoTrack: React.FC<Props> = ({
  cover,
  coverTrack,
  trackName,
  artist,
  overtop,
}) => {
  return (
    <>
      <div
        className={`flex w-full justify-center item-center pt-4 pb-5 ${
          !overtop && "pl-5"
        } md:pl-0`}
      >
        {coverTrack ? (
          <img
            className="w-full h-full object-cover"
            src={coverTrack}
            alt="cover"
          />
        ) : (
          <img className="w-full h-full object-cover" src={cover} alt="cover" />
        )}
      </div>
      <div className="flex justify-center items-center text-center">
        <div className="pb-5">
          <h4 className="text-xl font-bold">{trackName}</h4>
          <p className="text-base font-semibold">{artist}</p>
        </div>
      </div>
    </>
  );
};

export default InfoTrack;
